/* Border style module */
import {CSSProperties} from 'react';

import color from '../../color';

const radius = '8px';

export type BorderColor =
  | 'light'
  | 'extraLight'
  | 'emphasis'
  | 'hover'
  | 'transparent'
  | 'error';

export type RoundedBorder =
  | 'top'
  | 'right'
  | 'bottom'
  | 'left'
  | 'none'
  | 'all';

const border = (
  borderColorName?: BorderColor,
): Record<string, CSSProperties> => {
  let borderColor: string;
  switch (borderColorName) {
    case 'light':
      borderColor = color.graySXS;
      break;
    case 'extraLight':
      borderColor = color.grayXS;
      break;
    case 'emphasis':
      borderColor = color.emphasis;
      break;
    case 'error':
      borderColor = color.red;
      break;
    case 'hover':
      borderColor = color.hover;
      break;
    case 'transparent':
      borderColor = 'transparent';
      break;
    default:
      borderColor = color.grayM; // std -> regular
      break;
  }

  return {
    borderStd: {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor,
    },
    topBorderStd: {
      borderTop: `1px solid ${borderColor}`,
    },
    bottomBorderStd: {
      borderBottom: `1px solid ${borderColor}`,
    },
    leftBorderStd: {
      borderLeft: `1px solid ${borderColor}`,
    },
    rightBorderStd: {
      borderRight: `1px solid ${borderColor}`,
    },
    leftRightBorderStd: {
      borderLeft: `1px solid ${borderColor}`,
      borderRight: `1px solid ${borderColor}`,
    },
    topBottomBorderStd: {
      borderTop: `1px solid ${borderColor}`,
      borderBottom: `1px solid ${borderColor}`,
    },

    rounded: {
      borderRadius: radius,
    },
    topRounded: {
      borderRadius: `${radius} ${radius} 0 0`,
    },
    rightRounded: {
      borderRadius: `0 ${radius} ${radius} 0`,
    },
    bottomRounded: {
      borderRadius: `0 0 ${radius} ${radius}`,
    },
    leftRounded: {
      borderRadius: `${radius} 0 0 ${radius}`,
    },
    bottomRightRounded: {
      borderRadius: `0 ${radius} ${radius} ${radius}`,
    },

    circle: {
      borderRadius: '50%',
    },
  };
};

export const getBorder = (rounded?: RoundedBorder): CSSProperties => {
  switch (rounded) {
    case 'top':
      return border().topRounded;
    case 'right':
      return border().rightRounded;
    case 'bottom':
      return border().bottomRounded;
    case 'left':
      return border().leftRounded;
    case 'none':
      return {border: 'none'};
    default:
      return border().rounded;
  }
};

export default border;
